import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'app-constants';

const useStyles = makeStyles(theme => ({
  logo: {
    marginBottom: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
}));

const Logo: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.logo}>
      <img {...getAppImage(APP_IMAGES.Logo)} />
    </div>
  );
};

export default Logo;
